import { useState } from 'react';
import { ChevronDown, ChevronRight } from 'lucide-react';
import { ClinicalMarkdownBody } from './clinicalMarkdownComponents';

export interface ChartBriefingAccordionItem {
  title?: string;
  body_markdown?: string;
}

export function ChartBriefingCard({ item }: { item: ChartBriefingAccordionItem }) {
  // #115: response-body collapsibles start closed by default.
  const [open, setOpen] = useState(false);
  const md = String(item.body_markdown ?? '').trim();

  return (
    <div className="rounded-lg border border-border bg-surface-raised overflow-hidden">
      <button
        type="button"
        onClick={() => setOpen(!open)}
        className="w-full flex items-center gap-2 px-4 py-3 text-left hover:bg-surface-sunken/30 transition-colors"
        aria-expanded={open}
      >
        {open ? (
          <ChevronDown className="w-4 h-4 text-text-tertiary shrink-0" />
        ) : (
          <ChevronRight className="w-4 h-4 text-text-tertiary shrink-0" />
        )}
        <span className="text-[12px] font-medium uppercase tracking-[0.08em] text-text-tertiary flex-1">
          {item.title ?? 'Section'}
        </span>
      </button>
      {open && (
        <div className="px-4 pb-4 pt-1 border-t border-border">
          <div
            className="prose prose-sm dark:prose-invert max-w-none leading-relaxed
              prose-p:text-text-tertiary
              prose-p:my-1.5 prose-p:leading-[1.65]
              prose-strong:text-foreground prose-li:leading-[1.65]
              prose-ul:my-2 prose-ul:space-y-1 prose-li:my-0.5
              prose-ol:my-2 prose-headings:text-foreground prose-headings:font-medium
              prose-h2:text-[14px] prose-h3:text-[13px]"
          >
            <ClinicalMarkdownBody content={md || '—'} className="" />
          </div>
        </div>
      )}
    </div>
  );
}
